import {
    CREATE_EQUIPMENT,
    CREATE_EQUIPMENT_REQUEST,
    CREATE_EQUIPMENT_FAIL,
    SUBMIT_EQUIPMENT,
    SUBMIT_EQUIPMENT_REQUEST,
    SUBMIT_EQUIPMENT_FAIL,
    UPDATE_EQUIPMENT,
    UPDATE_EQUIPMENT_REQUEST,
    UPDATE_EQUIPMENT_FAIL,
    SET_EQUIPMENT_DRAFT,
    SET_EQUIPMENT_DRAFT_REQUEST,
    SET_EQUIPMENT_DRAFT_FAIL,
    SET_EQUIPMENT_SERVICED,
    SET_EQUIPMENT_SERVICED_REQUEST,
    SET_EQUIPMENT_SERVICED_FAIL,
    GET_EQUIPMENT,
    GET_EQUIPMENT_REQUEST,
    GET_EQUIPMENT_FAIL,
    GET_EQUIPMENTS,
    GET_EQUIPMENTS_REQUEST,
    GET_EQUIPMENTS_FAIL,
    GET_EQUIPMENTS_BY_USER,
    GET_EQUIPMENTS_BY_USER_REQUEST,
    GET_EQUIPMENTS_BY_USER_FAIL,
    GET_EQUIPMENTS_BY_LOCATION,
    GET_EQUIPMENTS_BY_LOCATION_REQUEST,
    GET_EQUIPMENTS_BY_LOCATION_FAIL,
    DELETE_EQUIPMENT,
    DELETE_EQUIPMENT_REQUEST,
    DELETE_EQUIPMENT_FAIL,

} from "../types/equipmentTypes"

const initState = {
    equipment: null,
    equipments: [],
    equipmentsByUser: [],
    error: null,
    loading: false,
  };

  const equipmentReducer = (state = initState, action) => {
    switch (action.type) {
        case CREATE_EQUIPMENT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CREATE_EQUIPMENT:
            return {
                ...state,
                equipment: action.payload.data,
                loading: false,
            };
        case CREATE_EQUIPMENT_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case UPDATE_EQUIPMENT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case UPDATE_EQUIPMENT:
            return {
                ...state,
                equipment: action.payload.data,
                loading: false
            }
        case UPDATE_EQUIPMENT_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        case SET_EQUIPMENT_DRAFT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case SET_EQUIPMENT_DRAFT:
            return {
                ...state,
                equipment: action.payload.data,
                loading: false
            }
        case SET_EQUIPMENT_DRAFT_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        case SET_EQUIPMENT_SERVICED_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case SET_EQUIPMENT_SERVICED:
            return {
                ...state,
                equipment: action.payload.data,
                loading: false
            }
        case SET_EQUIPMENT_SERVICED_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        case SUBMIT_EQUIPMENT_REQUEST:
            return {
                ...state,
                loading: true
            }
        case SUBMIT_EQUIPMENT: 
            return {
                ...state,
                equipment: action.payload.data,
                loading: false
            }
        case SUBMIT_EQUIPMENT_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }

        case GET_EQUIPMENTS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_EQUIPMENTS:
            return {
                ...state,
                loading: false,
                equipments: action.payload.data
            };
        case GET_EQUIPMENTS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case GET_EQUIPMENT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_EQUIPMENT:
            return {
                ...state,
                loading: false,
                equipment: action.payload.data,
            };
        case GET_EQUIPMENT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case GET_EQUIPMENTS_BY_USER_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_EQUIPMENTS_BY_USER:
            return {
                ...state,
                loading: false,
                equipmentsByUser: action.payload.data
            };
        case GET_EQUIPMENTS_BY_USER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case GET_EQUIPMENTS_BY_LOCATION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_EQUIPMENTS_BY_LOCATION:
            return {
                ...state,
                loading: false,
                equipments: action.payload.data
            };
        case GET_EQUIPMENTS_BY_LOCATION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        
        case DELETE_EQUIPMENT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case DELETE_EQUIPMENT:
            return {
                ...state,
                loading: false,
                equipment: action.payload,
            };
        case DELETE_EQUIPMENT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
    };

    export default equipmentReducer;

